import { IFetchBrandsDataPayload } from "actions/brands-data-actions";
import { ICopyProps } from "actions/collections/collection";
import { ConfirmDialog } from "components/dialog";
import { AlertDialog } from "components/dialog/alert";
import Dialog from "components/dialog/dialog";
import Button from "components/form/button";
import { ICurrency } from "components/product-collection/product-collection-views/product-collection-grid-view/grid-renderers/pinned-row-renderers";
import { SizeSettingsModal } from "components/size-settings/size-settings-modal";
import { AssortmentActions, SizeActions } from "constants/analytics";
import {
    ALLOCATION_DIMENSION_ID_PREFIX,
    CollectionAction,
    ExportCollectionSelectedSetting,
    ExportCollectionUnitType,
    ExportMerchant,
    ExportRequestType,
    getExportMerchantByName,
    IExportParams,
    ISizePacksTolerance,
    Item,
    NORD_DEPT_NAME,
    SizeAllocationType,
    View,
} from "constants/product-collection";
import { CollectionType } from "containers/folders/types/assortment";
import { AssortmentTemplate } from "containers/folders/types/base";
import { ISuggestionItem, ISuggestionObject } from "containers/product-collections/product-collection-cart";
import { $, keyframes, merge } from "glamor";
import { AllocationBag, IAllocationDimension } from "helpers/allocation-dimension";
import { IGridData } from "helpers/collection";
import { ICollectionVersionStatus } from "helpers/collection-version-status";
import { dateFormat } from "helpers/dates";
import {
    IDeliveryPurchaseOrder,
    IPurchaseOrderDoorGroup,
    purchaseOrderFieldsConstraints,
} from "helpers/delivery-purchase-order";
import { FeatureFlags } from "helpers/feature-flags";
import {
    canUseXLS,
    getDisplayNamesForField,
    getInOrFormula,
    getTagFilteredByPoi,
    IDisplayFields,
} from "helpers/product-collection";
import { itemHasEmptyUPCsorNRFs } from "helpers/sizing";
import { WindowAnalytics } from "helpers/window-analytics";
import { fromJS, List, Map, Set } from "immutable";
import { formatMessage } from "lib/globalize-util";
import _ from "lodash";
import CircularProgress from "material-ui/CircularProgress";
import MenuItem from "material-ui/MenuItem";
import me from "models/me";
import moment from "moment";
import React, { memo, useEffect, useState } from "react";
import { IBrandsDataStatePayload } from "reducers/brands-data-reducers";
import { IDoorTotal } from "reducers/collection";
import { DimensionsPanelReduxState } from "reducers/dimensions-panel/dimensions-panel";
import { ISubscription } from "reducers/subscriptions";
import { CopyAssortmentConfirmModalWithRedux } from "../../../utilities/copy-assortment-confirm-modal";
import { DeleteConfirmModal } from "../../../utilities/delete-confirm-modal";
import { ProductCollectionExportDialog } from "../../common/product-collection-export-dialog";
import { AllowedExportTypeOptions } from "../../product-collection-export-to-merchant/product-collection-export-to-merchant-modal";
import { IViews } from "../../product-collection-toolbar/constants";
import { generateDefaultColumnDefs } from "../../product-collection-views/product-collection-grid-view/product-collection-grid-view-helper";
import { CaptureSizeBulksDialog } from "../capture-size-bulks-dialog";
import { ExportCollectionUpcDialog } from "../collection-upc-management/export-collection-upc-dialog";
import { ImportCollectionUpcDialog } from "../collection-upc-management/import-collection-upc-dialog";
import { ExportMerchantDialog } from "../export-merchant";
import { RetailerSyncForm } from "../retailer-sync";
import MenuActions from "./menu-actions";

export interface IUser {
    identity: string;
    role: string;
}

const spin = keyframes({
    from: { transform: "rotate(0deg)" },
    to: { transform: "rotate(-360deg)" },
});

const actionStyles = {
    modal: {
        margin: "10px 0 0 0",
    },
    widget: {
        padding: "4px 0 0",
    },
};

const styles = merge(
    $(" .spinningWheel", {
        animation: `${spin} 2s infinite linear`,
    })
);

export interface CollectionActionsProps {
    collection?: any;
    onDeleteCollection: (id: string) => void;
    collectionId: string;
    collectionName: string;
    collectionBrandId?: string;
    merchantName: string;
    syncingProducts: boolean;
    allocatingAssortment: boolean;
    findingSizes: boolean;
    onSyncProductsStart: (isFiltered?: boolean) => void;
    onSyncProductsStop: () => void;
    capabilities: nuorder.folder.v1.Capabilities;
    collectionDriveItem: nuorder.folder.v1.Item;
    gridApi?: any;
    itemDisplayProperty?: List<any>;
    isMobileOrPhablet: boolean;
    isMobileOrPhaTablet: boolean;
    onSwitchView: (view: View) => void;
    rowDataSet: boolean;
    onExport: (params: IExportParams) => void;
    onCreateNordstromPush: (params: any) => any;
    collectionExport: any;
    onClearCollectionExport: () => void;
    location: any;
    editable: boolean;
    brandsDataById: IBrandsDataStatePayload["brandsDataById"];
    onToggleImageGroups: () => void;
    onToggleAddSMUDialog: () => void;
    requiredFieldNames: string[];
    desiredFieldNames: string[];
    getSuggestionData: () => ISuggestionObject;
    setSuggestionData: (data: ISuggestionItem[], storeKey: string) => void;
    handleFocusOnCellMap: () => Map<string, any>;
    onRemovePermission: (params) => void;
    user: IUser;
    onSubscribe: (targetFeedId: string) => void;
    onUnsubscribe: (targetFeedId: string) => void;
    subscription: ISubscription;
    onAllocateAllRows: (action: CollectionAction) => void;
    allocationEnabled: boolean;
    sizingRangeEnabled: boolean;
    sizingCurveEnabled: boolean;
    sizePackEnabled: boolean;
    onMatchSelectedSizesWithSizeRangesAllRows: (action: CollectionAction) => void;
    onCopy: (params: ICopyProps) => void;
    allocationDimensions: IAllocationDimension[];
    bulkItems: any;
    handleChangeView: (event) => void;
    view: View;
    views: IViews[];
    showTimeline: boolean;
    onToggleTimeline: () => void;
    itemId?: string;
    merchantId: string;
    legacyMerchantId: string;
    onOpenProductModal: (id) => void;
    merchantPurchaseOrderDoorGroups: IPurchaseOrderDoorGroup[];
    deliveryPurchaseOrders: IDeliveryPurchaseOrder[];
    sizeAllocationType?: SizeAllocationType;
    onOpenExportToMerchant: (validate) => void;
    merchantCurrency?: ICurrency;
    tileViewData?: IGridData;
    doorTotals?: {
        [door: string]: IDoorTotal;
    };
    versionStatuses?: ICollectionVersionStatus[];
    uniqueBrandEntities?: any[];
    onAddCollectionTag: (id: string) => void;
    onRemoveCollectionTag: () => void;
    poiTags: List<any>;
    currentPoi?: string;
    genericMerchantAllocationDimensions: IAllocationDimension[];
    fetchMerchantPreference: (merchantId) => void;
    fetchMerchantAllocationDimensions: (merchantId) => void;
    requestingMerchantAllocationDimensions: boolean;
    defaultDateFormat?: string;
    sizePacksTolerance: ISizePacksTolerance | null;
    updateCollectionSizePacksTolerance: (params: ISizePacksTolerance | null) => void;
    isFetchingBrandsData: boolean;
    onFetchBrandsData: (query: IFetchBrandsDataPayload["query"]) => void;
    merchantFeaturePreference?: any;
    onSyncInventoryUnitsAllRows: (action: CollectionAction) => void;
    syncingInventoryUnits: boolean;
    isCloseoutAssortmentEnabled: boolean;
    userMerchantId: string;
    allocationBagRef?: {
        allocationBag: AllocationBag;
    };
    flags: FeatureFlags;
    onOpenAssortmentSettings: () => void;
    dimensionsPanelApplied: DimensionsPanelReduxState;
    formulaFields: IDisplayFields;
    sizingAllocationEnabled: boolean;
}

export const ProductCollectionActions = memo((props: CollectionActionsProps) => {
    const [showSendToJWNAlert, setShowSendToJWNAlert] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [exportDialogOpen, setExportDialogOpen] = useState(false);
    const [exportMerchantDialogOpen, setExportMerchantDialogOpen] = useState(false);
    const [retailerSyncOpen, setRetailerSyncOpen] = useState(false);
    const [retailerSyncInvalidModalOpen, setRetailerSyncInvalidModalOpen] = useState(false);
    const [copyDialogOpen, setCopyDialogOpen] = useState(false);
    const [exportFileName, setExportFileName] = useState(props.collectionName);
    const [toGridViewModalOpen, setToGridViewModalOpen] = useState(false);
    const [hasMissedFields, setHasMissedFields] = useState(false);
    const [hasMultiDept, setHasMultiDept] = useState(false);
    const [showExportToMerchant, setShowExportToMerchant] = useState(
        [ExportMerchant.Saks, ExportMerchant.QaRetailer].includes(getExportMerchantByName(props.merchantName))
    );
    const [selectedVersionStatus, setSelectedVersionStatus] = useState(null);
    const [sizeSettingsDialogOpen, setSizeSettingsDialogOpen] = useState(false);
    const [shouldSaveAs, setShouldSaveAs] = useState(false);
    const [exportUpcDialogOpen, setExportUpcDialogOpen] = useState(false);
    const [importUpcDialogOpen, setImportUpcDialogOpen] = useState(false);

    const handleOpenDeleteDialog = () => setDeleteDialogOpen(true);
    const handleCloseDeleteDialog = () => setDeleteDialogOpen(false);

    const handleCloseRetailerSyncInvalidModal = () => setRetailerSyncInvalidModalOpen(false);

    const handleCloseToGridViewModal = () => setToGridViewModalOpen(false);

    const handleCloseExportToMerchantDialog = () => setExportMerchantDialogOpen(false);

    const handleSizeSettingsConfirm = (sizeSettingsParams: ISizePacksTolerance | null) => {
        setSizeSettingsDialogOpen(false);
        props.updateCollectionSizePacksTolerance(sizeSettingsParams);
    };

    const handleOpenSizeSettingsDialog = () => setSizeSettingsDialogOpen(true);

    const handleCloseSizeSettingsDialog = () => setSizeSettingsDialogOpen(false);

    const handleOpenExportDialog = () => setExportDialogOpen(true);

    const handleCloseExportDialog = () => {
        setExportDialogOpen(false);

        props.onClearCollectionExport();
    };

    const handleCloseSendToJWNAlert = () => setShowSendToJWNAlert(false);

    const handleOpenCopyDialog = () => setCopyDialogOpen(true);

    const handleCloseCopyDialog = () => {
        setCopyDialogOpen(false);
        setShouldSaveAs(false);
    };

    const handleOpenSaveAsDialog = () => {
        handleOpenCopyDialog();
        setShouldSaveAs(true);
    };

    const handleCopyAssortmentConfirm = (copyParams: ICopyProps) => {
        props.onCopy(copyParams);

        WindowAnalytics.track(AssortmentActions.CopyAssortment, {
            template: props.isCloseoutAssortmentEnabled ? AssortmentTemplate.Closeout : AssortmentTemplate.Standard,
            from: "Assortment",
        });
    };

    const handleConfirmDelete = () => {
        handleCloseDeleteDialog();

        props.onDeleteCollection(props.collectionId);
    };

    const handleOpenExportUpcDialog = () => setExportUpcDialogOpen(true);

    const handleCloseExportUpcDialog = () => {
        setExportUpcDialogOpen(false);

        props.onClearCollectionExport();
    };

    const handleOpenImportUpcDialog = () => setImportUpcDialogOpen(true);

    const handleCloseImportUpcDialog = () => setImportUpcDialogOpen(false);

    const handleOpenExportToMerchantDialog = () => {
        if (isGridGrouped()) {
            setExportMerchantDialogOpen(true);
            return;
        }

        // Validate fields before export or open modal with issues
        const { desiredFieldNames, requiredFieldNames } = getErrorAndWarningFields(props.gridApi);
        const { deliveryPORequiredFields, deliveryPODesiredFields } = getDeliveryPOErrorAndWarning();
        props.onOpenExportToMerchant(true);

        if (
            !requiredFieldNames.length &&
            !desiredFieldNames.length &&
            !deliveryPORequiredFields.length &&
            !deliveryPODesiredFields.length
        ) {
            handleExportToMerchant();
        } else if (props.gridApi) {
            // Only regenerate col defs when there is regular fields needed to be validated
            if (requiredFieldNames.length || desiredFieldNames.length) {
                const newDefaultColumnDefs = generateDefaultColumnDefs(props, true);
                props.gridApi.setColumnDefs(newDefaultColumnDefs);
            }

            setExportMerchantDialogOpen(true);
        }
    };

    const getParamsFromLocation = () => {
        const { query } = props.location;
        let { gridParams } = query;

        if (gridParams) {
            try {
                gridParams = JSON.parse(gridParams);
            } catch (e) {
                gridParams = {};
            }
        }
        return { gridParams };
    };

    const isGridGrouped = () => {
        const { gridParams } = getParamsFromLocation();
        return !_.isEmpty(gridParams) && Array.isArray(gridParams.rowGroup) && gridParams.rowGroup.length;
    };

    const handleOpenSendToRetailerDialog = () => {
        // NOTE: for tile view  we go back to grid view
        const { gridApi, requiredFieldNames, view, formulaFields } = props;

        const { gridParams } = getParamsFromLocation();

        if (!_.isEmpty(gridParams) && Array.isArray(gridParams.rowGroup) && gridParams.rowGroup.length) {
            setShowSendToJWNAlert(true);
        } else {
            if (view === View.Tile) {
                return setToGridViewModalOpen(true);
            }

            const [errorIndex, columnName, firstDiffDeptValueIndex, firstDiffDeptValue] = checkValidation(
                gridApi,
                formulaFields,
                requiredFieldNames,
                ExportCollectionSelectedSetting.Visible
            );

            const generateDefaultColumnDefsProps = {
                ...props,
                diffDeptChecker: { firstDiffDeptValue, fieldName: NORD_DEPT_NAME },
            };

            const newDefaultColumnDefs = generateDefaultColumnDefs(generateDefaultColumnDefsProps, true);

            gridApi.setColumnDefs(newDefaultColumnDefs);

            if (errorIndex === -1 && firstDiffDeptValueIndex === -1) {
                setRetailerSyncOpen(true);
            } else {
                if (errorIndex !== -1 && firstDiffDeptValueIndex !== -1) {
                    gridApi.ensureIndexVisible(errorIndex);
                    gridApi.ensureColumnVisible(columnName);
                    setRetailerSyncInvalidModalOpen(true);
                    setHasMissedFields(true);
                    setHasMultiDept(true);
                } else if (errorIndex !== -1) {
                    gridApi.ensureIndexVisible(errorIndex);
                    gridApi.ensureColumnVisible(columnName);
                    setRetailerSyncInvalidModalOpen(true);
                    setHasMissedFields(true);
                    setHasMultiDept(false);
                } else {
                    gridApi.ensureIndexVisible(firstDiffDeptValueIndex);
                    gridApi.ensureColumnVisible(NORD_DEPT_NAME);
                    setRetailerSyncInvalidModalOpen(true);
                    setHasMissedFields(false);
                    setHasMultiDept(true);
                }
            }
        }
    };

    const checkValidation = (
        gridApi,
        formulaFields,
        requiredFieldNames,
        checkAllRows?: ExportCollectionSelectedSetting
    ) => {
        let standardDeptValue = undefined;
        let firstErrorRowIndex = -1;
        let firstDiffDeptValueIndex = -1;
        let firstDiffDeptValue = undefined;
        let columnName = "";
        const forEachFn =
            checkAllRows === ExportCollectionSelectedSetting.Visible ? "forEachNodeAfterFilter" : "forEachNode";

        gridApi[forEachFn]((rowNode, index) => {
            const {
                data: { fields },
            } = rowNode;
            const deptStringValue = fields[NORD_DEPT_NAME]?.string_value;
            if (firstDiffDeptValueIndex === -1) {
                if (standardDeptValue && deptStringValue !== "" && standardDeptValue !== deptStringValue) {
                    firstDiffDeptValueIndex = index;
                    firstDiffDeptValue = deptStringValue;
                } else {
                    standardDeptValue =
                        deptStringValue === "" || deptStringValue === undefined ? undefined : deptStringValue;
                }
            }
            requiredFieldNames.forEach((key) => {
                if (formulaFields[key]) {
                    const formulaFieldValue = getInOrFormula(formulaFields[key], { fields }, false);
                    if (formulaFieldValue) {
                        return;
                    }
                }

                if (!fields[key]?.string_value) {
                    firstErrorRowIndex = firstErrorRowIndex === -1 ? index : firstErrorRowIndex;
                    columnName = columnName === "" ? key : columnName;
                }
            });
        });

        return [firstErrorRowIndex, columnName, firstDiffDeptValueIndex, firstDiffDeptValue];
    };

    const getErrorAndWarningFields = (gridApi, checkAllRows?: ExportCollectionSelectedSetting) => {
        const { requiredFieldNames, desiredFieldNames } = props;
        let requiredFieldNamesSet = Set<string>();
        let desiredFieldNamesSet = Set<string>();
        const forEachFn =
            checkAllRows === ExportCollectionSelectedSetting.Visible ? "forEachNodeAfterFilter" : "forEachNode";
        gridApi?.[forEachFn]((rowNode) => {
            if (!rowNode.group) {
                const {
                    data: { fields },
                } = rowNode;
                for (const field of requiredFieldNames) {
                    const cellValue = gridApi.getValue(field, rowNode);
                    if (field === Item.FIELDS.UPC[1]) {
                        const { upc } = itemHasEmptyUPCsorNRFs(fromJS({ fields }));
                        requiredFieldNamesSet = upc ? requiredFieldNamesSet.add(field) : requiredFieldNamesSet;
                    } else if (field === Item.FIELDS.NRF_SIZE_CODE[1]) {
                        const { nrf } = itemHasEmptyUPCsorNRFs(fromJS({ fields }));
                        requiredFieldNamesSet = nrf ? requiredFieldNamesSet.add(field) : requiredFieldNamesSet;
                    } else if (!cellValue) {
                        requiredFieldNamesSet = requiredFieldNamesSet.add(field);
                    }
                }
                for (const field of desiredFieldNames) {
                    const cellValue = gridApi.getValue(field, rowNode);
                    if (field === Item.FIELDS.UPC[1]) {
                        const { upc } = itemHasEmptyUPCsorNRFs(fromJS({ fields }));
                        desiredFieldNamesSet = upc ? desiredFieldNamesSet.add(field) : desiredFieldNamesSet;
                    } else if (field === Item.FIELDS.NRF_SIZE_CODE[1]) {
                        const { nrf } = itemHasEmptyUPCsorNRFs(fromJS({ fields }));
                        desiredFieldNamesSet = nrf ? desiredFieldNamesSet.add(field) : desiredFieldNamesSet;
                    } else if (!cellValue) {
                        desiredFieldNamesSet = desiredFieldNamesSet.add(field);
                    }
                }
            }
        });
        return { requiredFieldNames: requiredFieldNamesSet.toJS(), desiredFieldNames: desiredFieldNamesSet.toJS() };
    };

    const getDeliveryPOErrorAndWarning = () => {
        const { deliveryPurchaseOrders } = props;
        const fieldsMap = {
            required: [],
            desired: [],
        };

        // TODO: Tech debt. This should be configurable
        // Hardcoded recommendation for Ship Date and Cancel Date
        if (deliveryPurchaseOrders.length > 0) {
            for (const deliveryPurchaseOrder of deliveryPurchaseOrders) {
                if (!deliveryPurchaseOrder.active) {
                    continue;
                }

                purchaseOrderFieldsConstraints.forEach((constraint) => {
                    if (constraint.required && !deliveryPurchaseOrder[constraint.fieldName]) {
                        fieldsMap.required[constraint.fieldName] = true;
                    } else if (constraint.desired && !deliveryPurchaseOrder[constraint.fieldName]) {
                        fieldsMap.desired[constraint.fieldName] = true;
                    }
                });
            }
        }

        return {
            deliveryPORequiredFields: Object.keys(fieldsMap.required),
            deliveryPODesiredFields: Object.keys(fieldsMap.desired),
        };
    };

    const handleCloseSendToRetailerDialog = () => {
        const { gridApi, collectionName } = props;
        // NOTE: for tile view no gridApi
        const newDefaultColumnDefs = generateDefaultColumnDefs(props, false);
        gridApi.setColumnDefs(newDefaultColumnDefs);

        setRetailerSyncOpen(false);
        setExportFileName(collectionName);
    };

    const handleViewHistory = () => {
        const { onSwitchView } = props;
        onSwitchView(View.History);
    };

    const handleFindSizeRangesAllRows = () => {
        const { findingSizes, onMatchSelectedSizesWithSizeRangesAllRows } = props;
        onMatchSelectedSizesWithSizeRangesAllRows(findingSizes ? CollectionAction.Stop : CollectionAction.Start);
        const analytics = (global as any).analytics as any;
        if (!findingSizes) {
            analytics.track(SizeActions.FindSizeClicked);
        }
    };

    const handleSyncInventoryUnitsAllRows = () => {
        const { syncingInventoryUnits, onSyncInventoryUnitsAllRows } = props;
        onSyncInventoryUnitsAllRows(syncingInventoryUnits ? CollectionAction.Stop : CollectionAction.Start);
    };

    const handleAllocateAllRows = () => {
        const { allocatingAssortment, onAllocateAllRows } = props;
        onAllocateAllRows(allocatingAssortment ? CollectionAction.Stop : CollectionAction.Start);
    };

    const handleCancelSizeAllocation = () => {
        props.onAllocateAllRows(CollectionAction.Stop);
    };

    const handleVersionStatusClicked = (event) => {
        const { onRemoveCollectionTag, poiTags, currentPoi } = props;
        const currentTag = findTagByPoi(poiTags, currentPoi);
        const status = event.currentTarget.getAttribute("data-status");
        if (status) {
            status === currentTag ? onRemoveCollectionTag() : setSelectedVersionStatus(status);
        }
    };

    const handleViewExportStatusLog = () => {
        const { onSwitchView } = props;
        onSwitchView(View.ExportStatusLog);
    };
    const handleViewValidationErrorLog = () => {
        const { onSwitchView } = props;
        onSwitchView(View.ValidationErrorLog);
    };

    const handleCaptureModalClosed = () => setSelectedVersionStatus(null);

    const findTagByPoi = (poiTags: List<any>, currentPoi: string) =>
        getTagFilteredByPoi(poiTags, props.versionStatuses, currentPoi);

    const handleChangeExportName = (fileName: string) => setExportFileName(fileName);

    const handlePrepareDataToExportCollection = (exportParams: IExportParams) => {
        const formatDate =
            showExportToMerchant && exportMerchantDialogOpen
                ? moment().utc().format(dateFormat.LONG_FULL_DATE_FORMAT)
                : moment().format(dateFormat.LONG_FULL_DATE_FORMAT);
        const exportFileNameWithFormatDate = `${exportFileName}_${formatDate}`.replace(/[^0-9a-z\_\-\.]/gi, "_");

        props.onExport({
            ...exportParams,
            exportFileName: exportFileNameWithFormatDate,
        });

        if (exportMerchantDialogOpen) {
            handleCloseExportToMerchantDialog();
        }
    };

    const handleExportToMerchant = () => {
        props.onOpenExportToMerchant(false);
        handlePrepareDataToExportCollection({
            supplier: "",
            exportOnlyVisibleColumns: ExportCollectionSelectedSetting.All,
            exportOnlyVisibleRows: ExportCollectionSelectedSetting.All,
            withImages: false,
            withUnits: true,
            unitType: ExportCollectionUnitType.Actual,
            selectedAllocationDimensions: props.allocationDimensions.map((allocationDimension) =>
                allocationDimension.id.replace(ALLOCATION_DIMENSION_ID_PREFIX, "")
            ),
            horizontalAllocationDimensions: "",
            type: ExportRequestType.Ftp,
            actionMessage: getExportMerchantByName(props.merchantName),
            includeAssortmentId: true,
            showExportToMerchant,
        });
    };

    const handleSendToJWN = () => {
        const { gridApi, merchantName } = props;
        let newDefaultColumnDefs = generateDefaultColumnDefs(props, false);
        const excludeList = ["unit_retail_var_to_us"];
        newDefaultColumnDefs = newDefaultColumnDefs.filter((item) => !excludeList.includes(item.colId));
        gridApi.setColumnDefs(newDefaultColumnDefs);
        const { collectionId, collectionName } = props;
        const model = props.gridApi.getModel();
        const visibleRows = model.rowsToDisplay;
        const rowIds = visibleRows.map((rowNode) => rowNode.id);
        const exportName = exportFileName || collectionName;
        props.onCreateNordstromPush({ collectionId, rowIds, exportName, merchantName });
        handleCloseSendToRetailerDialog();
    };

    const handleSubscriptionAction = () => {
        const { subscription, onSubscribe, onUnsubscribe, collectionId } = props;

        if (subscription) {
            onUnsubscribe(collectionId);
        } else {
            onSubscribe(collectionId);
        }
    };

    useEffect(() => {
        const shouldShowExportToMerchant = [ExportMerchant.Saks, ExportMerchant.QaRetailer].includes(
            getExportMerchantByName(props.merchantName)
        );
        setShowExportToMerchant(shouldShowExportToMerchant);
    }, [props.merchantName]);

    if (!props.collectionId || (!canUseXLS && !props.editable)) {
        return null;
    }

    const currentTag = findTagByPoi(props.poiTags, props.currentPoi);
    const { desiredFieldNames, requiredFieldNames } = getErrorAndWarningFields(
        props.gridApi,
        ExportCollectionSelectedSetting.All
    );
    const { deliveryPORequiredFields, deliveryPODesiredFields } = getDeliveryPOErrorAndWarning();

    // Important: Send to JWN requires both `collection` and `itemDisplayProperty`.
    const isBrandUser = me.isBrandUser();
    const showJWN = props.merchantName === "nordstrom" && props.collection && props.itemDisplayProperty && !isBrandUser;

    const isBrandCollectionType =
        props.collectionDriveItem.collection_facet.collection_type === CollectionType.BrandStandard;
    const enabledExportActions = !!props.merchantFeaturePreference?.data_export?.exports?.find(
        (element) =>
            element.data_type === AllowedExportTypeOptions.PURCHASE_ORDER ||
            element.data_type === AllowedExportTypeOptions.ITEM
    )?.active;
    const showSaveAsAction = props.isCloseoutAssortmentEnabled && !isBrandUser && isBrandCollectionType;
    const showCopyAction = !isBrandCollectionType || (isBrandUser && isBrandCollectionType);

    const showAssortmentSettings =
        props.flags.assortmentSettings &&
        props.collectionDriveItem.collection_facet?.collection_type === CollectionType.External;
    const { active: canEditSizeLevelFields = false } =
        props.merchantFeaturePreference?.editable_size_level_fields ?? {};
    const isUpcManagementEnabled = props.sizingAllocationEnabled && canEditSizeLevelFields;

    return (
        <div className="widget" data-test="manage-upc-btn2" {...styles} style={actionStyles.widget}>
            <MenuActions
                onOpenAssortmentSettings={props.onOpenAssortmentSettings}
                showAssortmentSettings={showAssortmentSettings}
                allocatingAssortment={props.allocatingAssortment}
                bulkItems={props.bulkItems}
                findingSizes={props.findingSizes}
                syncingInventoryUnits={props.syncingInventoryUnits}
                syncingProducts={props.syncingProducts}
                isMobileOrPhablet={props.isMobileOrPhablet}
                isMobileOrPhaTablet={props.isMobileOrPhaTablet}
                showTimeline={props.showTimeline}
                onToggleTimeline={props.onToggleTimeline}
                views={props.views}
                view={props.view}
                handleChangeView={props.handleChangeView}
                editable={props.editable}
                itemId={props.itemId}
                onToggleAddSMUDialog={props.onToggleAddSMUDialog}
                showSaveAsAction={showSaveAsAction}
                handleOpenSaveAsDialog={handleOpenSaveAsDialog}
                onSyncProductsStop={props.onSyncProductsStop}
                onSyncProductsStart={props.onSyncProductsStart}
                sizePackEnabled={props.sizePackEnabled}
                handleOpenSizeSettingsDialog={handleOpenSizeSettingsDialog}
                sizingRangeEnabled={props.sizingRangeEnabled}
                handleFindSizeRangesAllRows={handleFindSizeRangesAllRows}
                sizingCurveEnabled={props.sizingCurveEnabled}
                handleAllocateAllRows={handleAllocateAllRows}
                isCloseoutAssortmentEnabled={props.isCloseoutAssortmentEnabled}
                isBrandUser={isBrandUser}
                handleSyncInventoryUnitsAllRows={handleSyncInventoryUnitsAllRows}
                versionStatuses={props.versionStatuses}
                currentTag={currentTag}
                handleVersionStatusClicked={handleVersionStatusClicked}
                handleViewHistory={handleViewHistory}
                showExportToMerchant={showExportToMerchant}
                merchantName={props.merchantName}
                handleOpenExportToMerchantDialog={handleOpenExportToMerchantDialog}
                enabledExportActions={enabledExportActions}
                handleViewValidationErrorLog={handleViewValidationErrorLog}
                handleViewExportStatusLog={handleViewExportStatusLog}
                canUseXLS={canUseXLS}
                handleOpenExportDialog={handleOpenExportDialog}
                showJWN={showJWN}
                showDeleteAction={props.capabilities.can_trash}
                handleOpenSendToRetailerDialog={handleOpenSendToRetailerDialog}
                subscription={props.subscription}
                handleSubscriptionAction={handleSubscriptionAction}
                canEdit={props.capabilities.can_edit}
                collectionId={props.collectionId}
                handleOpenCopyDialog={handleOpenCopyDialog}
                handleOpenDeleteDialog={handleOpenDeleteDialog}
                isUpcManagementEnabled={isUpcManagementEnabled}
                onOpenExportUpcDialog={handleOpenExportUpcDialog}
                onOpenImportUpcDialog={handleOpenImportUpcDialog}
                showCopyAction={showCopyAction}
            />

            <CaptureSizeBulksDialog
                tileViewData={props.tileViewData}
                doorTotals={props.doorTotals}
                onCapture={props.onAddCollectionTag}
                selectedVersionStatus={selectedVersionStatus}
                onRequestClose={handleCaptureModalClosed}
                uniqueBrandEntities={props.uniqueBrandEntities}
                poiTags={props.poiTags}
            />
            <DeleteConfirmModal
                onConfirm={handleConfirmDelete}
                onConfirmClose={handleCloseDeleteDialog}
                isDeleteConfirmationOpen={deleteDialogOpen}
            />
            {exportDialogOpen && (
                <ProductCollectionExportDialog
                    gridApi={props.gridApi}
                    allocationDimensions={props.allocationDimensions}
                    collectionExport={props.collectionExport}
                    onClose={handleCloseExportDialog}
                    onExport={handlePrepareDataToExportCollection}
                    isCloseoutAssortmentEnabled={props.isCloseoutAssortmentEnabled}
                />
            )}
            <ExportMerchantDialog
                title={formatMessage("We found some issues")}
                onRequestClose={handleCloseExportToMerchantDialog}
                open={exportMerchantDialogOpen}
                onExport={handleExportToMerchant}
                requiredFieldNames={requiredFieldNames}
                desiredFieldNames={desiredFieldNames}
                itemDisplayProperty={props.itemDisplayProperty}
                bypassDesiredConditions={props.collectionDriveItem?.capabilities?.can_share}
                requiredFieldsEmpty={requiredFieldNames.length === 0 && deliveryPORequiredFields.length === 0}
                desiredFieldsEmpty={desiredFieldNames.length === 0 && deliveryPODesiredFields.length === 0}
                isGridGrouped={isGridGrouped()}
                deliveryPORequiredFields={deliveryPORequiredFields}
                deliveryPODesiredFields={deliveryPODesiredFields}
            />
            {exportUpcDialogOpen && (
                <ExportCollectionUpcDialog
                    collectionName={props.collectionName}
                    onExport={props.onExport}
                    onClose={handleCloseExportUpcDialog}
                    collectionExport={props.collectionExport}
                    allocationDimensions={props.allocationDimensions}
                />
            )}
            {importUpcDialogOpen && <ImportCollectionUpcDialog onClose={handleCloseImportUpcDialog} />}

            <Dialog
                onRequestClose={handleCloseSendToJWNAlert}
                open={showSendToJWNAlert}
                title={formatMessage("Unable to send to JWN")}
            >
                <p>{formatMessage("Please ungroup your data before sending to JWN.")}</p>
            </Dialog>
            <ConfirmDialog
                title={formatMessage("Send to JWN?")}
                open={retailerSyncOpen}
                onConfirm={handleSendToJWN}
                onCancel={handleCloseSendToRetailerDialog}
            >
                <RetailerSyncForm fileName={exportFileName} onChangeFileName={handleChangeExportName} />
            </ConfirmDialog>
            <Dialog
                onRequestClose={handleCloseRetailerSyncInvalidModal}
                open={retailerSyncInvalidModalOpen}
                title={
                    hasMissedFields
                        ? hasMultiDept
                            ? formatMessage("Multiple Departments & Missing Required Fields")
                            : formatMessage("Missing Required Fields")
                        : hasMultiDept
                          ? formatMessage("Multiple Departments")
                          : ""
                }
            >
                {hasMultiDept && (
                    <p>
                        {formatMessage("Your selection includes more than one Dept value. Only one Dept is allowed.")}
                    </p>
                )}
                {hasMissedFields && (
                    <>
                        <p>
                            {formatMessage("These fields are required for Send to JWN: |requiredFields|.", {
                                requiredFields: getDisplayNamesForField(
                                    props.requiredFieldNames,
                                    props.itemDisplayProperty
                                ),
                            })}
                        </p>
                        <p>{formatMessage("Please fill in the missing fields and try your send again.")}</p>
                    </>
                )}
            </Dialog>
            <Dialog onRequestClose={handleCloseToGridViewModal} open={toGridViewModalOpen}>
                <MenuItem primaryText={formatMessage("Please switch to grid view.")} />
            </Dialog>
            <AlertDialog
                dismissButton={false}
                open={props.sizeAllocationType === SizeAllocationType.Class && props.allocatingAssortment}
                onRequestClose={handleCancelSizeAllocation}
                style={{ zIndex: 2000 }}
            >
                <div style={{ textAlign: "center", paddingTop: "20px" }}>
                    <CircularProgress />
                    <p>
                        {formatMessage(
                            "The sizing algorithm may take a few minutes to run. This dialogue will close once all sizing has completed."
                        )}
                    </p>
                    <Button
                        style={{ marginTop: "15px" }}
                        label={formatMessage("Cancel")}
                        onClick={handleCancelSizeAllocation}
                    />
                </div>
            </AlertDialog>

            {copyDialogOpen && (
                <CopyAssortmentConfirmModalWithRedux
                    onConfirm={handleCopyAssortmentConfirm}
                    onConfirmClose={handleCloseCopyDialog}
                    onSuccess={handleCloseCopyDialog}
                    isCopyConfirmationOpen={copyDialogOpen}
                    assortmentName={exportFileName}
                    isSaveAs={shouldSaveAs}
                />
            )}
            {sizeSettingsDialogOpen && (
                <SizeSettingsModal
                    onConfirm={handleSizeSettingsConfirm}
                    onConfirmClose={handleCloseSizeSettingsDialog}
                    onSuccess={handleCloseCopyDialog}
                    isSizeSettingsConfirmationOpen={sizeSettingsDialogOpen}
                    defaultSizePacksTolerance={props.sizePacksTolerance}
                />
            )}
        </div>
    );
});

ProductCollectionActions.displayName = "ProductCollectionActions";
